<template>
  <svg :width="size" :height="size" viewBox="0 0 20 20" fill="currentColor">
    <path d="M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4 7.968 7.968 0 0011 4.804V15a.5.5 0 01-1 0V4.804z"/>
  </svg>
</template>

<script>
export default {
  name: "IconBook",
  props: {
    size: { type: [Number, String], default: 20 },
  },
};
</script>
